import { render, staticRenderFns } from "./EstimateCanvas.vue?vue&type=template&id=cb4b43e2&scoped=true&"
import script from "./EstimateCanvas.vue?vue&type=script&lang=js&"
export * from "./EstimateCanvas.vue?vue&type=script&lang=js&"
import style0 from "./EstimateCanvas.vue?vue&type=style&index=0&id=cb4b43e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4b43e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
